import {Language} from '../utils/Localization'

/**
 * Application environment type.
 */
export enum AppEnvType {
  // Production environment (frontend + backend)
  PRODUCTION = 'PRODUCTION',
  // Test environment (frontend + backend)
  TEST = 'TEST',
  // Staging environment (frontend + backend)
  STAGING = 'STAGING',
  // Local development environment frontend working against local backend
  DEVELOPMENT = 'LOCAL_DEV',
  // Local development environment frontend working against test environment backend
  DEVELOPMENT_TEST = 'LOCAL_DEV_TEST'
}

const defaultLanguage: Language = Language.FI
/**
 * Default application environment (if value cannot be loaded from configs)
 */
const {PRODUCTION: defaultAppEnv} = AppEnvType

export const AppEnv = {
  getBackendBaseUrl,
  defaultLang: defaultLanguage
}

// note: for local development case, allow using different origin (port)
export const CREDENTIAL_POLICY = isDevEnvironment() ? 'include' : 'same-origin'

function isDevEnvironment(): boolean {
  const appEnv = getAppEnv()
  return appEnv === AppEnvType.DEVELOPMENT || appEnv === AppEnvType.DEVELOPMENT_TEST
}

function getBackendBaseUrl(): string {
  // eslint-disable-next-line @typescript-eslint/prefer-destructuring -- easier to locate when searched usage
  const overrideBackendBaseUrl = process.env.REACT_APP_BACKEND_URL
  return overrideBackendBaseUrl ?? ''
}

/* Helper Functions */

function getAppEnv(): AppEnvType {
  // eslint-disable-next-line @typescript-eslint/prefer-destructuring -- easier to locate when searched usage
  const appEnv = process.env.REACT_APP_ENV_TYPE
  if (!appEnv) {
    return defaultAppEnv
  }

  switch (appEnv) {
    case 'production':
      return AppEnvType.PRODUCTION
    case 'staging':
      return AppEnvType.STAGING
    case 'test':
      return AppEnvType.TEST
    case 'development':
      return AppEnvType.DEVELOPMENT
    case 'development-testenv':
      return AppEnvType.DEVELOPMENT_TEST
    default:
      return defaultAppEnv
  }
}
